import React from 'react';
import { useTranslation } from 'react-i18next';
import { searchLoanContacts, createLoanContact } from '../../api';
import UnifiedAutocomplete from './UnifiedAutocomplete';

interface LoanedToAutocompleteProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const LoanedToAutocomplete: React.FC<LoanedToAutocompleteProps> = ({
  value,
  onChange,
  placeholder = "Search or add a person..."
}) => {
  const { t } = useTranslation();
  const searchLoanContactNames = async (query: string, limit?: number) => {
    try {
      const loanContacts = await searchLoanContacts(query, limit);
      return loanContacts.map(loanContact => loanContact.name);
    } catch (error) {
      
      return [];
    }
  };

  const handleLoanContactCreation = async (data: { name: string }) => {
    const newLoanContact = await createLoanContact(data);
    return newLoanContact.name;
  };

  return (
    <UnifiedAutocomplete
      mode="string"
      value={value}
      onChange={onChange}
      searchFunction={searchLoanContactNames}
      createFunction={handleLoanContactCreation}
      placeholder={placeholder}
      createButtonText={(query) => t('autocomplete.createButtonText', { item: query })}
      searchingText={t('common.searching')}
      noItemsFoundText={(query) => t('autocomplete.noLoanContactsFound', { item: query })}
    />
  );
};

export default LoanedToAutocomplete;